import { useEffect, useState, useCallback } from "react";
import SliderOptions from "../sliderOptions";
import {
  UserRoundPlus,
  Eye,
  Pencil,
  Trash,
  UsersRound,
  Search,
  ChevronDown,
  FileDown,
  Check,
  X,
  Plus,
  ChevronLeft,
  ChevronRight,
} from "lucide-react"; // replace with your actual icon imports
import RoleCard from "../roleCard";
import CreateUser from "./createUser";
import Breadcrumb from "../breadCrumb";
import { RecruiterApi } from "../../../supports/recruiterApi";
import { generateRequestId } from "../../../common/common";
import Loader from "../../../common/loader";
import { useToast } from "../../../common/toastSystem";
import unifiedAuthManager from "../../../services/unifiedAuthManager";

const getRoleBadgeClass = (role) => {
  switch (role) {
    case "Admin":
      return "text-white bg-gradient px-5";
    case "Recruiter":
      return "text-orange-700 bg-orange-100";
    case "Candidate":
      return "text-yellow-700 bg-yellow-100";
    default:
      return "text-gray-700 bg-gray-100";
  }
};
const normalizeRole = (roleName) => {
  switch (roleName) {
    case "ROLE_ADMIN":
      return "Admin";
    case "ROLE_RECRUITER":
    case "ROLE_HR":
      return "Recruiter";
    case "ROLE_CANDIDATEUSER":
    case "ROLE_USER":
      return "Candidate";
    default:
      return "Candidate";
  }
};
const getUserRole = (roles) => {
  if (!Array.isArray(roles) || roles.length === 0) return null;
  return normalizeRole(roles[0].role_name);
};

const UserManagement = ({ onNavigate, isCreateUser = false }) => {
  const [users, setUsers] = useState([]);
  const [selectedTab, setSelectedTab] = useState("Users");
  const [roleFilter, setRoleFilter] = useState("Role");
  const [statusFilter, setStatusFilter] = useState("Status");
  const [createUserModalOpen, setCreateUserModalOpen] = useState(false);
  const [isRoleOpen, setIsRoleOpen] = useState(false);
  const [isStatusOpen, setIsStatusOpen] = useState(false);
  const roles = ["All", "Admin", "Recruiter", "Candidate"];
  const statuses = ["All", "Active", "Inactive"];
  const [selectAll, setSelectAll] = useState(false);
  const [broadbeanModalOpen, setBroadbeanModalOpen] = useState(false);
  const [debouncedSearch, setDebouncedSearch] = useState("");



  const roleCard = [
    {
      role: "Admin",
      count: 1,
      permissions: ["All"],
    },
    {
      role: "Recruiter",
      count: 45,
      permissions: ["View candidates", "Create jobs", "Download cvs"],
    },
    {
      role: "Candidate",
      count: 2800,
      permissions: [
        "View profile",
        "Apply jobs",
        "View candidates",
        "Create jobs",
        "Download cvs",
        "Create jobs",
        "Download cvs",
      ],
    },
  ];
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const pageSize = 50;
  const [isFetchCalling, setIsFetchCalling] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [userDetails, setUserDetails] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const toast = useToast();
  const [isBroadBeanCalled, setIsBroadBeanCalled] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isDeleteCalled, setIsDeleteCalled] = useState(false);
  const [rolesList, setRolesList] = useState([]);
  const [isCreateRoleOpen, setIsCreateRoleOpen] = useState(false);
  const [isRoleFetching, setIsRoleFetching] = useState(false);
  const [roleName, setRoleName] = useState("");
  const [isCreateRoleCalled, setIsCreateRoleCalled] = useState(false);
  const user = unifiedAuthManager.getUnifiedUser();

  const toggleCVAccess = (index) => {
    setUsers((prevUsers) =>
      prevUsers.map((user, i) =>
        i === index ? { ...user, toggleEnabled: !user.toggleEnabled } : user
      )
    );
  };
  // Open create-user modal when parent requests it via prop
  useEffect(() => {
    if (isCreateUser) {
      // reset any existing details and open the modal
      setUserDetails("");
      setCreateUserModalOpen(true);
    }
  }, [isCreateUser]);

 

  
    useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 600); // Wait 600ms after user stops typing

    return () => clearTimeout(timer); // Cleanup timer if user types again
  }, [searchQuery]);

   useEffect(() => {
    if (selectedTab === "Users") {
      setCurrentPage(1); // Reset to page 1 on new search/filter
      fetchUsersRole(1);
    } else {
      fetchAllRoles();
    }
  }, [debouncedSearch, selectedTab]);



  useEffect(() => {
    if (selectedTab === "Users" && currentPage !== 1) {
        // Only fetch if it's not the initial page load which is handled by the effect above
        fetchUsersRole(currentPage);
    }
  }, [currentPage]);



  const handleSelectAll = () => {
    const newValue = !selectAll;
    setSelectAll(newValue);
    setUsers(users.map((u) => ({ ...u, selected: newValue })));
  };
  const fetchUsersRole = async (page = 1) => {
    try {
      if (isFetchCalling) return;
      setIsFetchCalling(true);
      let requestPayload = {
        user_payload: {
          user_id: user.id,
          request_id: generateRequestId(),
          email: user.email,
          tenant: user.tenant,
        },
        page: page,
        count: pageSize,
        search: debouncedSearch,

      };
      const response = await RecruiterApi.userRoleManagement(requestPayload);
      setIsFetchCalling(false);
      setUsers(response.data.users || []);
      setTotalCount(response.data.total_count || 0);
      setCurrentPage(page);
    } catch (error) {
      setIsFetchCalling(false);
      console.log(error);
    }
  };
  const getUserStatus = (isActive) => {
    return isActive ? "Active" : "Inactive";
  };

  const handleSelectUser = (index) => {
    const updated = [...users];
    updated[index].selected = !updated[index].selected;
    setUsers(updated);
    setSelectAll(updated.every((u) => u.selected));
  };

  // const filteredUsers = users.filter((user) => {
  //   const name = `${user.first_name} ${user.last_name}`.toLowerCase();
  //   const email = user.email?.toLowerCase() || "";
  //   const role = getUserRole(user.roles)?.toLowerCase() || "";
  //   const status = user.is_active ? "active" : "inactive";
  //   const query = searchQuery.toLowerCase();
  //   const matchesSearch =
  //     name.includes(query) ||
  //     email.includes(query) ||
  //     role.includes(query) ||
  //     status.includes(query);
  //   const matchesRole =
  //     roleFilter === "All" ||
  //     roleFilter === "Role" ||
  //     role === roleFilter.toLowerCase();
  //   const matchesStatus =
  //     statusFilter === "All" ||
  //     statusFilter === "Status" ||
  //     status === statusFilter.toLowerCase();
  //   return matchesSearch && matchesRole && matchesStatus;
  // });

  const addBroadBeanUser = async () => {
    try {
      if (isBroadBeanCalled) return;
      setIsBroadBeanCalled(true);
      let requestPayload = {
        user_payload: {
          user_id: user.id,
          request_id: generateRequestId(),
          email: user.email,
          tenant: "GBB",
        },
        user_id: userDetails.user_id,
        broadbean_username: userDetails.broadbean_username,
      };
      const response = await RecruiterApi.addBroadBeanUser(requestPayload);
      setIsBroadBeanCalled(false);
      if (response.success) {
        fetchUsersRole(currentPage);
        setBroadbeanModalOpen(false);
        toast.success("Broadbean user added successfully!");
      } else {
        toast.warning("Failed to add broadbean user");
      }
    } catch (error) {
      setIsBroadBeanCalled(true);
      toast.warning("Failed to add broadbean user");
      console.log(error);
    }
  };

  const deleteUser = async (checked, userId) => {
    try {
      if (isDeleteCalled) return;
      setIsDeleteCalled(true);
      let requestPayload = {
        user_payload: {
          user_id: user.id,
          request_id: generateRequestId(),
          email: user.email,
          tenant: "GBB",
        },
        user_id: userId,
        action: checked ? "active" : "inactive",
      };
      const response = await RecruiterApi.updateUserStatus(requestPayload);
      setIsDeleteCalled(false);
      if (response.success) {
        setUsers((prevUsers) =>
          prevUsers.map((user) =>
            user.user_id === userId ? { ...user, is_active: checked } : user
          )
        );
        // fetchUsersRole(currentPage)
        // setIsDeleteModalOpen(false)
        toast.success(
          response.message || "User status updated successfully!",
          1500
        );
      } else {
        toast.warning(
          response.message || "User status updated successfully!",
          1500
        );
      }
    } catch (error) {
      setIsDeleteCalled(true);
      toast.warning("Failed to update the user status");
      console.log(error);
    }
  };

  const handleUserActivation = useCallback((checked, user) => {
    deleteUser(checked, user?.user_id);
  }, []);

  const fetchAllRoles = async () => {
    try {
      setIsRoleFetching(true);
      let user_payload = {
        user_payload: {
          request_id: generateRequestId(),
          user_id: user.id,
          tenant: "MPH",
          email: user.email,
        },
      };
      const res = await RecruiterApi.getAllRoles(user_payload);
      setIsRoleFetching(false);
      if (res.success) {
        setRolesList(res.data.roles);
      } else {
        toast.warning("Failed to load roles");
      }
    } catch (err) {
      setIsRoleFetching(false);
      console.error("Error loading roles:", err);
    }
  };

  const addRole = async () => {
    try {
      if (isCreateRoleCalled) return;
      setIsCreateRoleCalled(true);
      let user_payload = {
        user_payload: {
          request_id: generateRequestId(),
          user_id: user.id,
          tenant: "MPH",
          email: user.email,
        },
        name: roleName,
      };
      const res = await RecruiterApi.addRole(user_payload);
      setIsCreateRoleCalled(false);
      if (res.success) {
        fetchAllRoles();
        setIsCreateRoleOpen(false);
        setRoleName("");
        toast.success("Role added successfully!");
      } else {
        toast.warning("Failed to add roles");
      }
    } catch (err) {
      setIsCreateRoleCalled(false);
      console.error("Error adding roles:", err);
    }
  };

  const deleteRole = async () => {
    try {
      if (isDeleteCalled) return;
      setIsDeleteCalled(true);
      let requestPayload = {
        user_payload: {
          user_id: user.id,
          request_id: generateRequestId(),
          email: user.email,
          tenant: "GBB",
        },
        role_id: selectedRole?.role_id,
      };
      const response = await RecruiterApi.deleteRole(requestPayload);
      setIsDeleteCalled(false);
      if (response.success) {
        fetchUsersRole(currentPage);
        setIsDeleteModalOpen(false);
        toast.success("Role deleted successfully!");
      } else {
        toast.warning("Failed to delete this role");
      }
    } catch (error) {
      setIsDeleteCalled(true);
      toast.warning("Failed to delete this role");
      console.log(error);
    }
  };

  return (
    <main>
      {createUserModalOpen ? (
        <CreateUser
          user={userDetails}
          onBack={() => {
            fetchUsersRole(currentPage);
            setCreateUserModalOpen(false);
          }}
        />
      ) : (
        <div className="backdrop-blur-sm px-5 py-6">
          <div className="mb-2">
            <h1 className="text-base font-bold text-gray-333">
              Recruiter Management
            </h1>
            <div className="text-gray-500 text-xs">
              Manage recruiters and their roles
            </div>
          </div>
          <div className="flex justify-between items-center w-full anim-slideDown">
            {/* <div className="mb-2">
              <SliderOptions
                options={["Users"]}
                defaultValue={"Users"}
                onChange={(value) => setSelectedTab(value)}
              />
            </div> */}
            {/* {selectedTab === "Users" && (
                            <a className="flex gap-2 items-center bg-gradient text-white text-xs px-4 py-2 rounded-full w-fit cursor-pointer"
                                onClick={() => {
                                    setUserDetails('');
                                    setCreateUserModalOpen(true);
                                }}>
                                <UserRoundPlus size={16} /> Create User
                            </a>
                        )} */}
            {selectedTab === "Roles" && (
              <a
                className="flex gap-2 items-center bg-gradient text-white text-xs px-4 py-2 rounded-full w-fit cursor-pointer"
                onClick={() => {
                  setIsCreateRoleOpen(true);
                }}
              >
                <Plus size={16} /> Create role
              </a>
            )}
          </div>

          {selectedTab === "Users" && (
            <div className="bg-white rounded-lg shadow-sm overflow-hidden anim-slideUp">
              <div className="px-2 py-4 border-b border-gray-200 flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className="text-gray-500 bg-gray-100 m-2 rounded-full p-2">
                    <UsersRound size={16} />
                  </div>
                  <span className="text-sm font-semibold text-black">
                    Recruiters
                  </span>
                  <span className="text-xs text-gray-500 bg-gray-100 px-2 py-0.5 rounded-full">
                    {totalCount}
                  </span>
                </div>
                <div className="flex gap-4">
                  <div className="relative">
                    <Search
                      size={16}
                      className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
                    />
                    <input
                      type="text"
                      placeholder="Search users..."
                      className="pl-10 pr-4 py-2 text-xs text-ellipsis bg-gray-100 rounded-full focus:outline-none focus:ring-0 w-64"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>
                  {/* <div
                    className="relative"
                    onBlur={() => setIsRoleOpen(false)}
                    tabIndex={0}
                  >
                    <div
                      className={`flex items-center justify-between border text-gray-700 text-xs rounded-full px-4 py-2 w-32 cursor-pointer transition-all
                             ${
                               isRoleOpen ? "ring-1 ring-gray-300 bg-white" : ""
                             }`}
                      onClick={() => setIsRoleOpen(!isRoleOpen)}
                    >
                      <span>{roleFilter}</span>
                      <ChevronDown
                        size={14}
                        className={`text-gray-500 transform transition-transform duration-200 ${
                          isRoleOpen ? "rotate-180" : ""
                        }`}
                      />
                    </div>

                    {isRoleOpen && (
                      <div className="absolute mt-2 w-40 bg-white border border-gray-100 rounded-xl shadow-lg text-xs z-20 anim-slideDown">
                        {roles.map((role) => (
                          <div
                            key={role}
                            className={`px-4 py-2 cursor-pointer transition-all duration-150 text-gray-700 hover:bg-gray-100 hover:text-gray-900 ${
                              roleFilter === role
                                ? "bg-gray-50 font-semibold"
                                : ""
                            }`}
                            onClick={() => {
                              setRoleFilter(role);
                              setIsRoleOpen(false);
                            }}
                          >
                            {role}
                          </div>
                        ))}
                      </div>
                    )}
                  </div> */}

                  {/* Status Filter */}
                  {/* <div
                    className="relative"
                    onBlur={() => setIsStatusOpen(false)}
                    tabIndex={0}
                  >
                    <div
                      className={`flex items-center justify-between border text-gray-700 text-xs rounded-full px-4 py-2 w-32 cursor-pointer transition-all
                             ${
                               isStatusOpen
                                 ? "ring-1 ring-gray-300 bg-white"
                                 : ""
                             }`}
                      onClick={() => setIsStatusOpen(!isStatusOpen)}
                    >
                      <span>{statusFilter}</span>
                      <ChevronDown
                        size={14}
                        className={`text-gray-500 transform transition-transform duration-200 ${
                          isStatusOpen ? "rotate-180" : ""
                        }`}
                      />
                    </div>
                    {isStatusOpen && (
                      <div className="absolute mt-2 w-40 bg-white border border-gray-100 rounded-xl shadow-lg text-xs z-20 anim-slideDown">
                        {statuses.map((status) => (
                          <div
                            key={status}
                            className={`px-4 py-2 cursor-pointer transition-all duration-150 text-gray-700 hover:bg-gray-100 hover:text-gray-900 ${
                              statusFilter === status
                                ? "bg-gray-50 font-semibold"
                                : ""
                            }`}
                            onClick={() => {
                              setStatusFilter(status);
                              setIsStatusOpen(false);
                            }}
                          >
                            {status}
                          </div>
                        ))}
                      </div>
                    )}
                  </div> */}
                </div>
              </div>

              <div className="overflow-y-auto h-[calc(100vh-17rem)]">
                {isFetchCalling ? (
                  <Loader />
                ) : (
                  <table className="w-full anim-slideUp">
                    <thead className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
                      <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider flex gap-2">
                          {/* <label className="relative inline-flex items-center cursor-pointer group">
                            <input
                              type="checkbox"
                              checked={selectAll}
                              onChange={handleSelectAll}
                              className="peer appearance-none h-4 w-4 rounded-md bg-white border checked:bg-[#B2853D] transition-all duration-200 cursor-pointer"
                            />
                            <Check
                              size={12}
                              className="absolute text-white left-0.5 opacity-0 peer-checked:opacity-100 transition-opacity"
                            />
                          </label> */}
                          <span className="ml-2">Name</span>
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Email
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          {/* Role */}
                          Broadbean Username
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Status
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200 text-xs">
                      {users.length === 0 ? (
                        <tr>
                          <td
                            colSpan="5"
                            className="text-center px-6 py-8 text-gray-400"
                          >
                            There is no user
                          </td>
                        </tr>
                      ) : (
                        users.map((user, index) => (
                          <tr key={index} className="hover:bg-gray-50 relative">
                            <td className="px-6 py-4 whitespace-nowrap text-xs font-medium text-gray-900 flex gap-2">
                              {/* <label className="relative inline-flex items-center cursor-pointer group">
                                <input
                                  type="checkbox"
                                  checked={user.selected}
                                  onChange={() => handleSelectUser(index)}
                                  className="peer appearance-none h-4 w-4 border rounded-md bg-white checked:bg-[#B2853D] transition-all duration-200 cursor-pointer"
                                />
                                <Check
                                  size={12}
                                  className="absolute text-white left-0.5 opacity-0 peer-checked:opacity-100 transition-opacity"
                                />
                              </label> */}
                              <span className="font-medium text-gray-800">
                                {user.first_name} {user.last_name}
                              </span>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-xs text-gray-600">
                              {user.email}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              {user?.broadbean_username || "-"}
                              {/* {user.roles && user.roles.length > 0 ? (
                                <span
                                  className={`px-3 py-1 text-xs font-medium rounded-full ${getRoleBadgeClass(
                                    getUserRole(user.roles)
                                  )}`}
                                >
                                  {getUserRole(user.roles)}
                                </span>
                              ) : (
                                <span className="p-2">-</span>
                              )} */}
                            </td>
                            <td
                              className={`px-6 py-4 whitespace-nowrap text-xs ${
                                user.is_active
                                  ? "text-gray-600"
                                  : "text-gray-400"
                              }`}
                            >
                              <span
                                className={`text-xs rounded-full px-3 py-1 ${
                                  user.is_active
                                    ? "bg-yellow-50"
                                    : "bg-gray-100"
                                }`}
                              >
                                {getUserStatus(user.is_active)}
                              </span>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-xs">
                              <div className="flex items-center gap-3">
                                <button
                                  className={`text-gray-500 hover:text-gray-800 transition-colors border rounded-full p-1 ${
                                    !user.is_active ? "cursor-not-allowed" : ""
                                  }`}
                                  title="Edit"
                                  disabled={!user.is_active}
                                  onClick={() => {
                                    setUserDetails(user);
                                    setCreateUserModalOpen(true);
                                  }}
                                >
                                  <Pencil size={16} />
                                </button>
                                <button
                                  onClick={() => {
                                    setUserDetails(user);
                                    setBroadbeanModalOpen(true);
                                  }}
                                  className={`text-gray-500 hover:text-gray-800 transition-colors border rounded-full p-1`
                                }
                                  // disabled={
                                  //   !user.is_active 
                                  //   ||getUserRole(user.roles) == "Candidate"
                                  // }
                                  title="Add Broadbean username"
                                >
                                  <UserRoundPlus size={16} />
                                </button>
                                {/* Add a toggle switch */}
                                <label className="relative inline-flex items-center cursor-pointer">
                                  <input
                                    type="checkbox"
                                    title={
                                      user.is_active
                                        ? "Deactivate User"
                                        : "Activate User"
                                    }
                                    checked={user.is_active}
                                    onChange={(e) => {
                                      setUserDetails(user);
                                      handleUserActivation(
                                        e.target.checked,
                                        user
                                      );
                                    }}
                                    className="sr-only peer"
                                  />
                                  <div className="w-9 h-5 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-[#8ccbc9]"></div>
                                </label>

                                {/* <button className={`text-gray-500 hover:text-gray-800 transition-colors border rounded-full p-1 ${!user.is_active ? 'cursor-not-allowed' : ''}`} title="Delete" disabled={!user.is_active} onClick={() => {
                                                                    setUserDetails(user);
                                                                    setIsDeleteModalOpen(true)
                                                                }}>
                                                                    <Trash size={16} />
                                                                </button> */}

                                <button
                                  onClick={() => toggleCVAccess(index)}
                                  title={
                                    user.toggleEnabled
                                      ? "Disable recruiter CV downloads"
                                      : "Enable recruiter CV downloads"
                                  }
                                  className={`hidden relative inline-flex h-5 w-9 items-center rounded-full transition-colors ${
                                    user.toggleEnabled
                                      ? "bg-gradient"
                                      : "bg-gray-300"
                                  }`}
                                >
                                  <FileDown
                                    size={10}
                                    className={`absolute transition-opacity ${
                                      user.toggleEnabled
                                        ? "opacity-100 left-1 text-white"
                                        : "opacity-100 right-1 text-black"
                                    }`}
                                  />
                                  <span
                                    className={`inline-block h-4 w-4 transform rounded-full bg-white transition ${
                                      user.toggleEnabled
                                        ? "translate-x-5"
                                        : "translate-x-1"
                                    }`}
                                  ></span>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                )}
              </div>
              <div className="flex justify-end gap-4 items-center p-4 border-t">
                <button
                  disabled={currentPage === 1 }
                  onClick={() => setCurrentPage((prev) => prev - 1)}
                  className={`px-1 py-1 text-xs rounded-full border
      ${
        currentPage === 1 
          ? "opacity-40 cursor-not-allowed"
          : "hover:bg-gray-100"
      }`}
                >
                  <ChevronLeft size={14} />
                </button>

                <div className="text-xs text-gray-600">
                  Page {currentPage} of {Math.ceil(totalCount / pageSize)}
                </div>

                <button
                  disabled={
                    currentPage === Math.ceil(totalCount / pageSize)
                  }
                  onClick={() => setCurrentPage((prev) => prev + 1)}
                  className={`px-1 py-1 text-xs rounded-full border
      ${
        currentPage === Math.ceil(totalCount / pageSize) 
          ? "opacity-40 cursor-not-allowed"
          : "hover:bg-gray-100"
      }`}
                >
                  <ChevronRight size={14} />
                </button>
              </div>
            </div>
          )}

          {selectedTab === "Roles" && (
            <div className="anim-slideUp">
              <div className="flex justify-between">
                <div className=" py-4 px-2 text-gray-600 text-sm">
                  <h2 className="text-sm text-black font-semibold">Roles</h2>
                  <p className="text-xs text-gray-500">Configure roles</p>
                </div>

                <div></div>
              </div>
              <div className="overflow-y-auto h-[calc(100vh-14rem)]">
                {isRoleFetching ? (
                  <Loader />
                ) : (
                  <table className="w-full anim-slideUp">
                    <thead className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
                      <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Role name
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200 text-xs">
                      {rolesList.length === 0 ? (
                        <tr>
                          <td
                            colSpan="5"
                            className="text-center px-6 py-8 text-gray-400"
                          >
                            There is no user
                          </td>
                        </tr>
                      ) : (
                        rolesList.map((role, index) => (
                          <tr key={index} className="hover:bg-gray-50 relative">
                            <td className="px-6 py-4 whitespace-nowrap text-xs text-gray-600">
                              {role.role_name}
                            </td>
                            <td className="px-6 py-3 text-left">
                              <button
                                className={`text-gray-666 hover:text-gray-800 transition-colors border rounded-full p-1 `}
                                title="Delete"
                                onClick={() => {
                                  setSelectedRole(role);
                                  setIsDeleteModalOpen(true);
                                }}
                              >
                                <Trash size={16} />
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          )}
        </div>
      )}
      {broadbeanModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30 anim-slideDown">
          <div className="w-full max-w-md text-left bg-white rounded-xl shadow-lg p-4 relative flex flex-col max-h-[90vh]">
            <div className="flex justify-between items-center border-b pb-2">
              <div className="text-left">
                <h2>Add Broadbean Username</h2>
              </div>
              <div
                className="border rounded-full p-1 cursor-pointer hover:bg-gray-100"
                onClick={() => setBroadbeanModalOpen(false)}
              >
                <X size={16} />
              </div>
            </div>
            <div className="flex flex-col">
              <label className="text-xs text-gray-600 mt-4 mb-1">
                Username
              </label>
              <input
                type="text"
                value={userDetails.broadbean_username}
                onChange={(e) =>
                  setUserDetails((prev) => ({
                    ...prev,
                    broadbean_username: e.target.value,
                  }))
                }
                className="rounded-lg text-xs px-2 py-2 focus:outline-none focus:ring-0 bg-gray-100"
                placeholder="Enter Broadbean username"
              />
            </div>
            <div className="mt-6 flex justify-end gap-2">
              <button
                onClick={() => setBroadbeanModalOpen(false)}
                className="p-1.5 px-4 text-xs rounded-full border border-gray-300 hover:bg-gray-100 transition-all"
              >
                Cancel
              </button>
              <button
                onClick={() => addBroadBeanUser()}
                disabled={isBroadBeanCalled || !userDetails.broadbean_username}
                className={`cursor-pointer p-1.5 px-4 text-xs rounded-full bg-gradient text-white transition-all ${
                  isBroadBeanCalled || !userDetails.broadbean_username
                    ? "cursor-not-allowed"
                    : ""
                }`}
              >
                {isBroadBeanCalled ? "Saving..." : "Add"}
              </button>
            </div>
          </div>
        </div>
      )}
      {isDeleteModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30 anim-slideDown">
          <div className="w-[60vh] text-left bg-white rounded-xl shadow-lg p-4 relative item-center justify-center flex flex-col gap-6 h-[30vh]">
            <div className="text-sm text-gray-333 flex items-center justify-center">
              {selectedTab === "Users"
                ? "Are you sure you want to delete this user?"
                : selectedTab === "Roles"
                ? "Are you sure you want to delete this role?"
                : "Are you sure you want to delete?"}
            </div>
            <div className="mt-4 flex justify-center gap-2">
              <button
                onClick={() => {
                  setUserDetails("");
                  setSelectedRole("");
                  setIsDeleteModalOpen(false);
                }}
                className="p-1.5 px-4 text-xs rounded-full border border-gray-300 hover:bg-gray-100 transition-all"
              >
                Cancel
              </button>
              {selectedTab === "Users" ? (
                <button
                  onClick={() => deleteUser()}
                  disabled={isDeleteCalled}
                  className={`cursor-pointer p-1.5 px-4 text-xs rounded-full bg-gradient text-white transition-all ${
                    isDeleteCalled ? "cursor-not-allowed" : ""
                  }`}
                >
                  {isDeleteCalled ? "Deleting" : "Delete"}
                </button>
              ) : selectedTab === "Roles" ? (
                <button
                  onClick={() => deleteRole()}
                  disabled={isDeleteCalled}
                  className={`cursor-pointer p-1.5 px-4 text-xs rounded-full bg-gradient text-white transition-all ${
                    isDeleteCalled ? "cursor-not-allowed" : ""
                  }`}
                >
                  {isDeleteCalled ? "Deleting" : "Delete"}
                </button>
              ) : null}
            </div>
          </div>
        </div>
      )}
      {isCreateRoleOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30 anim-slideDown">
          <div className="w-full max-w-md text-left bg-white rounded-xl shadow-lg p-4 relative flex flex-col max-h-[90vh]">
            <div className="flex justify-between items-center border-b pb-2">
              <div className="text-left">
                <h2>Add new role.</h2>
              </div>
              <div
                className="border rounded-full p-1 cursor-pointer hover:bg-gray-100"
                onClick={() => {
                  setRoleName("");
                  setIsCreateRoleOpen(false);
                }}
              >
                <X size={16} />
              </div>
            </div>
            <div className="flex flex-col">
              <label className="text-xs text-gray-600 mt-4 mb-1">
                Role name
              </label>
              <input
                type="text"
                value={roleName}
                onChange={(e) => setRoleName(e.target.value)}
                className="rounded-lg text-xs px-2 py-2 focus:outline-none focus:ring-0 bg-gray-100"
                placeholder="Enter role name"
              />
            </div>
            <div className="mt-6 flex justify-end gap-2">
              <button
                onClick={() => {
                  setRoleName("");
                  setIsCreateRoleOpen(false);
                }}
                className="p-2 px-4 text-xs rounded-full border border-gray-300 hover:bg-gray-100 transition-all"
              >
                Cancel
              </button>
              <button
                onClick={() => addRole()}
                disabled={!roleName || isCreateRoleCalled}
                className={`cursor-pointer p-2 px-6 text-xs rounded-full bg-gradient text-white transition-all ${
                  !roleName || isCreateRoleCalled ? "cursor-not-allowed" : ""
                }`}
              >
                {isCreateRoleCalled ? "Adding.." : "Add"}
              </button>
            </div>
          </div>
        </div>
      )}
    </main>
  );
};

export default UserManagement;
